let obj = {};
obj.companyIdTypeOptions = [
    {
        value: "04",
        name: "营业执照"
    },
]
obj.policyNameList = [
    {
        value: "仲利国际融资租赁有限公司",
        name: "仲利国际融资租赁有限公司",
        idType:"04",
        idNumber:"91310000717854863X",
        telephone:'021-522080101',
        address:'上海市长宁区金钟路631弄1号楼',
        type:'C',
        postCode:'200335'
    },
    {
        value: "仲津国际租赁有限公司",
        name: "仲津国际租赁有限公司",
        idType:"04",
        idNumber:"911201185661255901",
        telephone:'022-84861168',
        address:'天津空港经济区环河北路76号空港商务园西区13-1,2-401',
        type:'C',
        postCode:'300308'
    },
    {
        value: "仲利国际贸易（上海）有限公司",
        name: "仲利国际贸易（上海）有限公司",
        idType:"04",
        idNumber:"913101086778047729",
        telephone:'021-522080101',
        address:'上海市江场三路228号408室',
        type:'C',
        postCode:'200436'
    },
]
obj.plansValues = [
    {
        name: '方案一',
        value: 'P04014D01'
    },
    {
        name: '方案二',
        value: 'P04014D02'
    },
    {
        name: '方案三',
        value: 'P04014D03'
    }
]
//企业类型
obj.industryType = [
    {
        name: '法人',
        value: 'C',
    }
]
// 申请人类别
obj.applicantType = [
    {
        name: '法人',
        value: 'C',
    },
    {
        name: '自然人',
        value: 'I',
    }
]
export default { ...obj }